import { graphql } from "react-relay"
import { useMutationWithErrorToast } from "@/hooks/useMutationWithErrorToast"
import { useChCareProviderSendChangeRequestMutation as useChCareProviderSendChangeRequestMutationType } from "@/modules/care-provider/components/edit-care-provider/services/__generated__/useChCareProviderSendChangeRequestMutation.graphql"

const mutation = graphql`
  mutation useChCareProviderSendChangeRequestMutation($input: Ch_sendCareProviderChangeRequestInput!) {
    ch_sendCareProviderChangeRequest(input: $input) {
      changeRequest {
        id
      }
      errors {
        ... on Error {
          message
        }
      }
    }
  }
`

export const useChCareProviderSendChangeRequestMutation = () => {
  return useMutationWithErrorToast<useChCareProviderSendChangeRequestMutationType>(mutation)
}
